import React from "react";
import Container from "../common/Container";
import ETHIcon from "../../assets/img/common/ETH-icon.svg";
import MATICIcon from "../../assets/img/common/MATIC-icon.svg";
import BNBIcon from "../../assets/img/common/BNB-icon.svg";
import ARBIcon from "../../assets/img/common/ARB-icon.svg";
import OPIcon from "../../assets/img/common/OP-icon.svg";
import CELOIcon from "../../assets/img/common/CELO-icon.svg";

const blockchains = [
  { name: "Polygon", icon: MATICIcon },
  { name: "Arbitrum", icon: ARBIcon },
  { name: "Ethereum", icon: ETHIcon },
  { name: "Optimism", icon: OPIcon },
  { name: "BSC", icon: BNBIcon },
  { name: "Celo", icon: CELOIcon },
];

const SupportedBlockchains = () => {
  return (
    <section className="w-full py-16 lg:py-20 bg-gradient-to-b from-secondary to-[#1a1230] relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-primary/5 via-transparent to-transparent pointer-events-none"></div>
      
      <Container className="relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white abel-font mb-3">
            Supported Blockchains
          </h2>
          <p className="text-white/60 max-w-xl mx-auto">
            Implemented and tested on best performing EVM-compatible blockchain networks
          </p>
        </div>

        {/* Blockchain Icons */}
        <div className="flex flex-wrap justify-center items-center gap-8 lg:gap-12">
          {blockchains.map((chain, index) => (
            <div
              key={index}
              className="group flex flex-col items-center gap-3 p-4 rounded-2xl hover:bg-white/5 transition-all duration-300"
            >
              <div className="w-16 h-16 lg:w-20 lg:h-20 rounded-2xl bg-white/10 backdrop-blur-md flex items-center justify-center group-hover:scale-110 transition-transform duration-300 border border-white/10">
                <img
                  src={chain.icon}
                  alt={chain.name}
                  className="w-10 h-10 lg:w-12 lg:h-12"
                />
              </div>
              <span className="text-white/70 text-sm font-medium group-hover:text-white transition-colors">
                {chain.name}
              </span>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default SupportedBlockchains;
